// Sticky bar — show after scrolling past hero
const stickyBar = document.getElementById('stickyBar');
const heroSection = document.querySelector('.hero');
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) {
      stickyBar.classList.add('visible');
    } else {
      stickyBar.classList.remove('visible');
    }
  });
}, { threshold: 0 });
observer.observe(heroSection);

// Scroll-triggered fade-in
const fadeEls = document.querySelectorAll('.bento-card, .objection-card, .review-card, .feature-block, .value-item, .faq-item');
const fadeObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1';
      entry.target.style.transform = entry.target.style.transform ? entry.target.style.transform.replace('translateY(20px)', 'translateY(0)') : 'translateY(0)';
    }
  });
}, { threshold: 0.1 });

fadeEls.forEach(el => {
  const rect = el.getBoundingClientRect();
  if (rect.top < window.innerHeight && rect.bottom > 0) {
    el.style.opacity = '1';
  } else {
    el.style.opacity = '0';
    el.style.transform = (el.style.transform || '') + ' translateY(20px)';
  }
  el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
  fadeObserver.observe(el);
});